function toUrlEncodedFromProducts(productsData) {
  var urlEncodedData = new URLSearchParams();

  if (Array.isArray(productsData)) {
    productsData.forEach(function (product, index) {
      urlEncodedData.append('ProductAlerts[' + index + '].Product', product.Product || '');
      urlEncodedData.append('ProductAlerts[' + index + '].Title', product.Title || '');
      urlEncodedData.append('ProductAlerts[' + index + '].ServiceArea', product.ServiceArea || '');
      urlEncodedData.append('ProductAlerts[' + index + '].Frequency', product.Frequency || '');
      urlEncodedData.append('ProductAlerts[' + index + '].AlertEnabled', product.AlertEnabled ? 'true' : 'false');
      urlEncodedData.append('ProductAlerts[' + index + '].IsChecked', product.IsChecked ? 'true' : 'false');
    });
  }

  return urlEncodedData.toString();
}

export function saveProductAlertPreferences(productsData) {
  var payload = toUrlEncodedFromProducts(productsData);

  return fetch('/Account/api/PreferencesApi/UpdatePreferences', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: payload
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('API request failed with status: ' + response.status);
      }
      return response.json();
    })
    .catch(function (error) {
      console.error('Product Preferences API Error:', error);
      return {
        success: false,
        error: error.message,
        message: 'Failed to save product preferences'
      };
    });
}

export function saveSavedSearchAlertPreferences(formData) {
  return fetch('/api/SavedSearches/SaveAlertPreferences', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formData
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('API request failed with status: ' + response.status);
      }
      return response.json();
    })
    .catch(function (error) {
      console.error('Saved Search Preferences API Error:', error);
      return {
        success: false,
        error: error.message,
        message: 'Failed to save saved search preferences'
      };
    });
}

